import { List, ListProps } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useTimeSheetStore } from 'stores/timeSheet.store'
import StaffItem from './StaffItem'

interface StaffListProps extends ListProps {
  staffs: any
  isOpenSidebar: boolean
}

export default function StaffList({ staffs, isOpenSidebar, ...other }: StaffListProps) {
  const [staffSelectedCode, setStaffSelectedCode] = useTimeSheetStore((state) => [
    state.staffSelectedCode,
    state.setStaffSelectedCode
  ])
  const activeStaffRef = useRef<HTMLDivElement | null>(null)

  const handleSelectStaff = (staffCode: string) => {
    setStaffSelectedCode(staffCode)
  }

  useEffect(() => {
    if (activeStaffRef.current) {
      activeStaffRef.current.scrollIntoView({ behavior: 'auto', block: 'center' })
    }
  }, [staffSelectedCode])
  return (
    <List disablePadding {...other} className="overflow-scroll h-[calc(100vh-170px)]">
      {staffs?.map((staff: any) => (
        <div
          key={staff.staffCode}
          ref={staff.staffCode === staffSelectedCode ? activeStaffRef : null}
        >
          <StaffItem
            key={staff.staffCode}
            isOpenSidebar={isOpenSidebar}
            staff={staff}
            isSelected={staff.staffCode === staffSelectedCode}
            onSelectStaff={() => handleSelectStaff(staff.staffCode)}
          />
        </div>
      ))}
    </List>
  )
}
